export enum FilterOptionType {
    HeadingOnly = 1,
    HeadingAndSubheading,
    HeadingAndPictureUrl
}

export enum FilterType {
    MultiSelect = 1,
    SearchableMultiSelect,
    SingleSelect,
    SearchableSingleSelect,
    SingleSelectDateRange,
    Toggle,
    CombinationSingleSelect
}
